module.exports = __webpack_public_path__ + "static/media/magnum.4d620f9e.jpg";